import {
    GET_IMAGE_LINK,
    LOAD_ANNOUNCEMENT,
    LOAD_ANNOUNCEMENT_ERROR,
    LOAD_ANNOUNCEMENT_SUCCESS,
    REMOVE_ANNOUNCEMENT, REMOVE_ANNOUNCEMENT_ERROR,
    REMOVE_ANNOUNCEMENT_SUCCESS
} from "./constants";


export function loadAnnouncements() {
    return {
        type: LOAD_ANNOUNCEMENT,
    };
}

export function announcementsLoaded(data) {
    return {
        type: LOAD_ANNOUNCEMENT_SUCCESS,
        payload: {data},
    };
}

export function announcementsLoadingError(error) {
    return {
        type: LOAD_ANNOUNCEMENT_ERROR,
        payload: {error},
    };
}

export function removeAnnouncement(id) {
    return {
        type: REMOVE_ANNOUNCEMENT,
        payload: {id},
    };
}

export function removeAnnouncementSuccess() {
    return {
        type: REMOVE_ANNOUNCEMENT_SUCCESS,
    };
}

export function removeAnnouncementError(error) {
    return {
        type: REMOVE_ANNOUNCEMENT_ERROR,
    };
}

export function getImageLink(fileId, meta) {
    return {
        type: GET_IMAGE_LINK,
        meta,
        payload: {fileId},
    };
}